<template>
<div class="flex-box">
    <router-link to="/statistics/index" class="item">
        <van-button  :type="active ===1 ?'info': 'default'">使用情况</van-button>
    </router-link>
    <router-link to="/statistics/system" class="item">
        <van-button  :type="active ===2 ?'info': 'default'">系统分布</van-button>
    </router-link>
    <router-link to="/statistics/version" class="item">
        <van-button  :type="active ===3 ?'info': 'default'">版本分布</van-button>
    </router-link>
</div>
</template>

<script>
export default {
    props: ['active'],
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.flex-box{
    width: 100%;
    display: flex;
    align-content: space-between;
    margin-bottom: 20px;
    .item{
        flex: 1;
        text-align: center;
    }
}
</style>
